/** Funnel mock — membership mode. */

export const FUNNEL_MOCK_MEMBERSHIP = {
  mode: 'membership',
  dataSourceLabel: 'VM Platform · CMP',
  confidence: {
    tone: 'success',
    title: 'High confidence — CMP product lines only.',
  },
  kpis: [
    {
      id: 'conversion',
      label: 'Season-card conversion',
      value: '12.4%',
      detail: '1,280 of 10,300 eligible',
    },
    {
      id: 'dropoff',
      label: 'Biggest drop-off',
      value: 'Ticket → Season card',
      detail: '−9,020 · 87.6%',
    },
    {
      id: 'pending',
      label: 'Pending tickets',
      value: '2,100',
      detail: 'Held out of %',
    },
    {
      id: 'online_share',
      label: 'Online share',
      value: '71% · +5 pt',
      detail: 'Season cards skew online',
    },
  ],
  chart: {
    title: 'Membership & add-ons',
    stages: [
      {
        id: 'ticket_purchased',
        index: '01',
        label: 'Ticket purchased',
        total: 12400,
        converted: 10300,
        dropped: 0,
        pending: 2100,
        pendingLabel: '2,100 pending',
      },
      {
        id: 'season_card',
        index: '02',
        label: 'Season card / membership',
        total: 10300,
        converted: 1280,
        dropped: 9020,
        pending: 0,
        conversionLabel: '12.4%',
        droppedLabel: '−9,020 no membership',
      },
      {
        id: 'add_on',
        index: '03',
        label: 'Ticket-linked add-on',
        subtitle: 'optional',
        total: 10300,
        converted: 1860,
        dropped: 8440,
        pending: 0,
        conversionLabel: '18.1%',
        droppedLabel: '−8,440 no add-on',
      },
    ],
  },
  pending: null,
  insight: {
    eyebrow: 'Biggest weak point',
    title: 'Most single-ticket buyers never see a membership offer.',
    action: 'Surface a season-card upsell on the online confirmation page.',
  },
  stageInsights: {
    ticket_purchased: {
      eyebrow: 'Baseline',
      title: '10,300 eligible ticket buyers after pending held out.',
      action: 'Compare attach rates by channel next.',
    },
    season_card: {
      eyebrow: 'Biggest weak point',
      title: 'Most single-ticket buyers never see a membership offer.',
      action: 'Surface a season-card upsell on the online confirmation page.',
    },
    add_on: {
      eyebrow: 'Add-ons',
      title: '18% take a ticket-linked add-on — stronger online than on-site.',
      action: 'Bundle jersey/discount offers at online checkout.',
    },
  },
  steps: [
    {
      id: 'ticket_purchased',
      step: '01 Ticket purchased',
      entered: '12,400',
      converted: '10,300 eligible',
      dropOff: '—',
      medianTime: '—',
    },
    {
      id: 'season_card',
      step: '02 Season card',
      entered: '10,300',
      converted: '1,280 (12.4%)',
      dropOff: '9,020',
      medianTime: 'same session',
    },
    {
      id: 'add_on',
      step: '03 Add-on',
      entered: '10,300',
      converted: '1,860 (18.1%)',
      dropOff: '8,440',
      medianTime: 'same session',
    },
  ],
};
